const getProductSub = (): string | undefined => {
    //undefined in IE
    //https://developer.mozilla.org/en-US/docs/Web/API/Navigator/productSub
    return navigator.productSub as string | undefined;
}

export default getProductSub;